<template>
  <div class="view pm teams">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3"><strong>Teams Management</strong></h3>
      </div>
      <div class="content">
        <div class="teams-wrap" v-if="teams">
          <table>
            <tbody>
              <tr>
                <th>No.</th>
                <th>Name</th>
                <th>Alias</th>
                <th>Leader</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
              <tr class="team" v-for="(team, i) in teams" :key="team._id">
                <th>{{ i + 1 }}</th>
                <td>{{ team.name }}</td>
                <td>{{ team.alias }}</td>
                <td>{{ team.leader }}</td>
                <td>{{ team.phone }}</td>
                <td>{{ team.email }}</td>
                <th style="text-align: center">Edit</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as teamsService from '@/services/pm/teams'

export default {
  data() {
    return {
      teams: [],
    }
  },
  async created() {
    this.teams = await teamsService.fetchTeams()
  },
}
</script>

<style lang="scss" scoped>
table {
  td,
  th {
    padding: 6px;
  }
  tr:nth-child(odd) {
    background-color: #f3f3f3f3;
  }
}
</style>
